/**
 * Valeur d'onboarding côté API / stockage : ignorer chaînes vides ou littérales "null".
 */
export function isValidOnboardingTimestamp(v: unknown): boolean {
  if (v == null) return false;
  if (typeof v !== 'string') return false;
  const s = v.trim();
  if (!s) return false;
  const lower = s.toLowerCase();
  if (lower === 'null' || lower === 'undefined') return false;
  return true;
}
